var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('router-link',{staticClass:"capitalize badge badge-pill badge-info mr-1",attrs:{"to":{ name: 'Biblia', params: _vm.params, query: { destaque: _vm.nome } }}},[_vm._v(_vm._s(_vm.citacao))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }